import { blue20opacity15, blue50, blue60 } from '../../../colors/blue';
import { gray40, gray55, gray70, gray80, white } from '../../../colors/gray';
import { neutral02, neutral60opacity10, neutral60opacity20 } from '../../../colors/neutral';
import { red03 } from '../../../colors/red';
import { rem } from '../../../utils/rem';
import { shape } from '../shape';
export var MuiOutlinedInput = {
    styleOverrides: {
        root: {
            // paddingInline: rem(14),
            // paddingBlock: rem(16.5),
            // paddingInlineEnd: rem(14),
            backgroundColor: white,
            '&:hover [class*=MuiOutlinedInput-notchedOutline]': {
                borderColor: gray70,
            },
            '&[class*=Mui-focused] [class*=MuiOutlinedInput-notchedOutline]': {
                borderColor: blue60,
            },
            '&[class*=Mui-error] [class*=MuiOutlinedInput-notchedOutline]': {
                borderColor: red03,
            },
            '&& [class*=MuiSelect-select].MuiInputBase-input': {
                paddingInlineEnd: rem(32),
            },
            '& [class*=MuiSelect-icon]': {
                right: rem(7),
            },
            '&[class*=MuiSelect-secondary]': {
                backgroundColor: 'transparent',
                color: blue50,
                minWidth: rem(60),
                width: 'fit-content',
                '&:hover': {
                    backgroundColor: neutral60opacity10,
                },
                '&[class*=Mui-focused]': {
                    backgroundColor: blue20opacity15,
                },
                '& [class*=MuiSelect-icon]': {
                    color: blue60,
                },
                '&:not([class*=Mui-focused]):not([class*=Mui-error])': {
                    '& [class*=MuiOutlinedInput-notchedOutline]': {
                        border: 'none',
                    },
                    '&:hover [class*=MuiOutlinedInput-notchedOutline]': {
                        border: 'none',
                    },
                },
                '&[class*=Mui-disabled]': {
                    opacity: 0.4,
                },
            },
            '&:not([class*=MuiInputBase-multiline]):not([class*=MuiAutocomplete-inputRoot]):not([class*=MuiSelect-sizeSmall])': {
                height: rem(30),
            },
            '& [class*=MuiIconButton-edgeEnd]': {
                borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
                height: rem(30),
                marginInlineEnd: 0,
                width: rem(30),
                '&:hover': {
                    backgroundColor: neutral60opacity20,
                },
                '&:active': {
                    backgroundColor: blue20opacity15,
                },
            },
            '&[class*=MuiAutocomplete-inputRoot][class*=MuiOutlinedInput-root]': {
                paddingBottom: 0,
                paddingTop: 0,
                '& input[class*=MuiAutocomplete-input]': {
                    height: rem(30),
                    paddingBottom: 0,
                    paddingTop: 0,
                },
            },
            '&[class*=MuiSelect-sizeSmall]': {
                fontSize: '0.775rem',
                height: rem(26),
                '& [class*=MuiSelect-iconOutlined]': {
                    top: rem(5),
                },
            },
            '&[class*=Mui-disabled]': {
                pointerEvents: 'none',
            },
            '& input': {
                paddingBottom: rem(7),
                paddingTop: rem(7),
            },
            '& input::placeholder': {
                fontStyle: 'italic',
            },
            // Handle a case when a button is inside the input adornments by resetting some undesired button's attributes.
            '& [class*=MuiInputAdornment]': {
                '& [class*=MuiButton-root]': {
                    minWidth: 0,
                    padding: 0,
                },
                '&[class*=MuiInputAdornment-positionEnd] [class*=MuiButtonBase-root]': {
                    marginInlineEnd: -14,
                },
                '&[class*=MuiInputAdornment-positionStart] [class*=MuiButtonBase-root]': {
                    marginInlineStart: -14,
                },
            },
            // Adjust styles for the filled variant of input adornments.
            '& [class*=MuiInputAdornment-filled]': {
                backgroundColor: neutral02,
                borderColor: neutral60opacity20,
                borderStyle: 'solid',
                borderWidth: 0,
                color: gray55,
                height: rem(30),
                marginTop: '0 !important',
                paddingInline: rem(14),
                '&[class*=MuiInputAdornment-positionStart]': {
                    borderInlineEndWidth: rem(1),
                    marginInlineStart: -14,
                },
                '&[class*=MuiInputAdornment-positionEnd]': {
                    borderInlineStartWidth: rem(1),
                    marginInlineEnd: -14,
                },
            },
        },
        notchedOutline: {
            borderColor: gray40,
        },
        adornedEnd: {
            '& svg': {
                color: gray80,
            },
        },
        adornedStart: {
            '& svg': {
                color: gray80,
            },
        },
    },
};
